<p class="mb-8 font-medium text-4xl">{{ data().priceViewTitle }}</p>
@if (config()) {
    <div class="flex sm:flex-row flex-col justify-between gap-8">
        @for (season of config()?.data?.seasons; track $index) {
            <div
                class="flex-1"
                (click)="
                    bookingService.config.reload();
                    selectedSeason.set(season);
                    scrollTo('price-table')
                "
            >
                @defer {
                    <img
                        [src]="domhandler.getSmallestImageAsWebp(season.image)"
                        [srcset]="domhandler.generateSrcsetAsWebp(season.image)"
                        alt="season image"
                        loading="lazy"
                        class="w-full object-cover aspect-square cursor-pointer"
                    />
                } @placeholder {
                    <ngx-skeleton-loader
                        class="block w-full aspect-square"
                        [theme]="{ height: '100%' }"
                    />
                }
                <p class="my-4 text-2xl text-center">
                    {{
                        "priceView.season"
                            | translate: { name: getCorrectSeasonName(season) }
                    }}
                </p>
                <app-button class="block justify-self-center">
                    {{ "priceView.showPrices" | translate }}
                </app-button>
            </div>
        }
    </div>
    @if (selectedSeason()) {
        @let subSeason = selectedSeason()!.subSeasons[0];
        @if (bookingService.config.isLoading()) {
            <ngx-skeleton-loader
                count="3"
                class="flex flex-col gap-4 mt-12 w-2/5"
                [theme]="{ height: '1.5rem', backgroundColor: 'lightgray' }"
            />
        } @else {
            <p class="mt-12 font-medium text-2xl">
                {{
                    "priceView.priceTableHeader"
                        | translate
                            : {
                                  seasonName:
                                      getCorrectSeasonName(selectedSeason()),
                              }
                }}
            </p>
            <p>
                {{
                    "priceView.basePriceInfo"
                        | translate
                            : {
                                  minimumPeople:
                                      config()?.data
                                          ?.minimumPeopleForBasePrices || 4,
                                  basePrice: subSeason.basePrice,
                                  cleaningCosts:
                                      subSeason.cleaningCosts *
                                      (config()?.data
                                          ?.minimumPeopleForBasePrices || 4),
                              }
                }}
                {{
                    "priceView.additionalPersonInfo"
                        | translate
                            : {
                                  cleaningCostsPerPerson:
                                      subSeason.cleaningCosts,
                              }
                }}
                {{
                    "priceView.additionalAdultInfo"
                        | translate: { adultPrice: subSeason.adultPrice }
                }}
                {{
                    "priceView.additionalChildInfo"
                        | translate: { childPrice: subSeason.childPrice }
                }}
            </p>
        }
    }

    <section class="overflow-x-auto" id="price-table">
        @if (selectedSeason()) {
            @let subSeason = selectedSeason()!.subSeasons[0];
            @if (bookingService.config.isLoading()) {
                <table class="mt-4 w-full">
                    <thead>
                        <tr>
                            <th></th>
                            @for (i of array(); track $index) {
                                <th class="text-left">
                                    {{ i }}
                                    @if (i > 1) {
                                        {{ "priceView.persons" | translate }}
                                    } @else {
                                        Person
                                    }
                                </th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                {{ "priceView.adults" | translate }}
                            </td>
                            @for (i of array(); track $index) {
                                @if (
                                    i >
                                    (config()?.data
                                        ?.minimumPeopleForBasePrices || 4)
                                ) {
                                    <td>
                                        <ngx-skeleton-loader
                                            class="block w-2/5"
                                            [theme]="{
                                                height: '1.5rem',
                                                backgroundColor: 'lightgray',
                                            }"
                                        />
                                    </td>
                                } @else {
                                    <td>
                                        <ngx-skeleton-loader
                                            class="block w-2/5"
                                            [theme]="{
                                                height: '1.5rem',
                                                backgroundColor: 'lightgray',
                                            }"
                                        />
                                    </td>
                                }
                            }
                        </tr>
                        <tr>
                            <td>
                                {{ "priceView.children" | translate }}
                            </td>
                            @for (i of array(); track $index) {
                                @if (
                                    i >
                                    (config()?.data
                                        ?.minimumPeopleForBasePrices || 4)
                                ) {
                                    <td>
                                        <ngx-skeleton-loader
                                            class="block w-2/5"
                                            [theme]="{
                                                height: '1.5rem',
                                                backgroundColor: 'lightgray',
                                            }"
                                        />
                                    </td>
                                } @else {
                                    <td>
                                        <ngx-skeleton-loader
                                            class="block w-2/5"
                                            [theme]="{
                                                height: '1.5rem',
                                                backgroundColor: 'lightgray',
                                            }"
                                        />
                                    </td>
                                }
                            }
                        </tr>
                        <tr>
                            <td>
                                {{ "priceView.cleaningCosts" | translate }}
                            </td>
                            @for (i of array(); track $index) {
                                <td>
                                    <ngx-skeleton-loader
                                        class="block w-2/5"
                                        [theme]="{
                                            height: '1.5rem',
                                            backgroundColor: 'lightgray',
                                        }"
                                    />
                                </td>
                            }
                        </tr>
                    </tbody>
                </table>
            } @else {
                <table class="mt-4 w-full">
                    <thead>
                        <tr>
                            <th></th>
                            @for (i of array(); track $index) {
                                <th class="text-left">
                                    {{ i }}
                                    @if (i > 1) {
                                        {{ "priceView.persons" | translate }}
                                    } @else {
                                        Person
                                    }
                                </th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                {{ "priceView.adults" | translate }}
                            </td>
                            @for (i of array(); track $index) {
                                @if (
                                    i >
                                    (config()?.data
                                        ?.minimumPeopleForBasePrices || 4)
                                ) {
                                    <td>
                                        {{
                                            subSeason.basePrice +
                                                subSeason.adultPrice *
                                                    (i -
                                                        (config()?.data
                                                            ?.minimumPeopleForBasePrices ||
                                                            4))
                                        }}
                                        €
                                    </td>
                                } @else {
                                    <td>{{ subSeason.basePrice }} €</td>
                                }
                            }
                        </tr>
                        <tr>
                            <td>
                                {{ "priceView.children" | translate }}
                            </td>
                            @for (i of array(); track $index) {
                                @if (
                                    i >
                                    (config()?.data
                                        ?.minimumPeopleForBasePrices || 4)
                                ) {
                                    <td>
                                        {{
                                            subSeason.basePrice +
                                                subSeason.childPrice *
                                                    (i -
                                                        (config()?.data
                                                            ?.minimumPeopleForBasePrices ||
                                                            4))
                                        }}
                                        €
                                    </td>
                                } @else {
                                    <td>{{ subSeason.basePrice }} €</td>
                                }
                            }
                        </tr>
                        <tr>
                            <td>
                                {{ "priceView.cleaningCosts" | translate }}
                            </td>
                            @for (i of array(); track $index) {
                                <td>
                                    {{
                                        subSeason.cleaningCosts *
                                            (i >
                                            (config()?.data
                                                ?.minimumPeopleForBasePrices ||
                                                4)
                                                ? i
                                                : config()?.data
                                                      ?.minimumPeopleForBasePrices ||
                                                  4)
                                    }}
                                    €
                                </td>
                            }
                        </tr>
                    </tbody>
                </table>
            }
        }
    </section>
    @if (selectedSeason()) {
        <a
            [routerLink]="[
                '/',
                this.languageService.getLanguageCode,
                'apartment',
                'buchen',
            ]"
            class="block mt-8"
        >
            <app-button>
                {{ "priceView.bookNow" | translate }}
            </app-button>
        </a>
    }
}
